import React from "react";
import { useParams, useNavigate } from "react-router-dom";
import LeadDetails from "../../preneed-section/booking-and-appointment/lead-details";

function PreneedLeadDetailsWrapper() {
  const { id } = useParams();
  const navigate = useNavigate();
  return (
    <LeadDetails
      leadId={Number(id)}
      onBack={() => navigate(-1)}
    />
  );
}
export default PreneedLeadDetailsWrapper;